module.exports = __webpack_public_path__ + "img/slide-3.04047e4.webp";